import styled from "styled-components";

export const WLadyDesktop = styled.img<{ useVariant?: boolean }>`
    position: absolute;
    bottom:  ${({ useVariant }) => useVariant ? "13.9%" : "18.9%"};
    left: 36.5%;
    width: 40%;
    height: auto;
`;

export const TLKeyboardDesktop = styled.img`
    position: absolute;
    bottom: 63%;
    height: auto;
    left: 7%;
    width: 26.5%;
`;